import type { IInvitationResponse } from "./welcomeInvitation"

export interface IWelcomeInvitationConfigResponse extends IInvitationResponse {}

export class WelcomeInvitationConfig {
  public id?: number
  public title?: string
  public message?: string
  public rsvpMessage?: string
  public rsvpDate?: Date
  public ctaMessage?: string
  public rsvpEnabled?: boolean
  public rsvpEmailEnabled?: boolean
  public allowSongRequests?: boolean
  public allowDietaryRequirements?: boolean
  public allowPublicGuestList?: boolean

  constructor(welcomeInvitation: Partial<WelcomeInvitationConfig>) {
    this.id = welcomeInvitation.id
    this.title = welcomeInvitation.title
    this.message = welcomeInvitation.message
    this.rsvpMessage = welcomeInvitation.rsvpMessage
    this.rsvpDate = welcomeInvitation.rsvpDate
    this.ctaMessage = welcomeInvitation.ctaMessage
    this.rsvpEnabled = welcomeInvitation.rsvpEnabled
    this.rsvpEmailEnabled = welcomeInvitation.rsvpEmailEnabled
    this.allowSongRequests = welcomeInvitation.allowSongRequests
    this.allowDietaryRequirements = welcomeInvitation.allowDietaryRequirements
    this.allowPublicGuestList = welcomeInvitation.allowPublicGuestList
  }

  public static fromResponse(response?: IWelcomeInvitationConfigResponse) {
    return new WelcomeInvitationConfig ({
      id: response?.invitationId,
      title: response?.title,
      message: response?.invitationMessage,
      rsvpMessage: response?.rsvpMessage,
      rsvpDate: response?.rsvpDate,
      ctaMessage: response?.callToActionMessage,
      rsvpEnabled: response?.rsvpEnabled,
      rsvpEmailEnabled: response?.rsvpEmailEnabled,
      allowSongRequests: response?.allowSongRequests,
      allowDietaryRequirements: response?.allowDietaryRequirements,
      allowPublicGuestList: response?.allowPublicGuestList,
    })
  }
}
